import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import less from 'less'
import './assets/css/base.less';
import weui from 'weui.js'
import 'weui'
import {
  preventReClick
} from './preventReClick/preventReClick';

import axios from 'axios'
import 'amfe-flexible/index'
Vue.config.productionTip = false
Vue.use(less)
Vue.prototype.$weui = weui
Vue.use(preventReClick)
Vue.config.productionTip = false
axios.defaults.baseURL = 'http://test.dangwuyou.net/' //线上接口
// axios.defaults.baseURL = 'http://rswy.natapp4.cc/' //测试接口
Vue.prototype.$http = axios
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(config => {
  config.headers.token = window.localStorage.getItem('token')
  return config
})
axios.interceptors.response.use(response => {
  const data = response.data;
  if (data.code == 0) {
    return response;
  } else if (data.code == 401) {
    // weui.topTips('登录过期，请重新登录');
    localStorage.clear();
    router.replace('/login');
  } else {
    weui.topTips(data.msg);
    return response;
  }
  return response
}, (err) => {
  weui.topTips('连接错误，请重试');
  return Promise.resolve(err);
});


router.beforeEach((to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title
  } else {
    document.title = '海查查'
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
